export default "__VITE_ASSET__72826331__"